<template>
  <div class="job-detail-page">
    <div class="job-detail">
      <div class="content-card">
        <div class="head-row">
          <h1 class="job-title">{{ jobDetail?.postName || '-'}}</h1>
          <p class="salary">{{ jobDetail?.salary || '-' }}</p>
        </div>

        <div class="location-row">
          <van-icon name="location-o" />
          <span>{{ formatLocationText(jobDetail) || '-'}}</span>
        </div>
        
        <div class="meta-block">
          <div class="meta-row">
            <span>{{jobDetail?.recruitTypeStr || '-' }}</span>
            <span>{{ jobDetail?.postTypeStr || '-' }}</span>
            <span>{{ jobDetail?.educationLevel || '-' }}</span>
            <span>{{ jobDetail?.wantNum || '-' }}</span>
          </div>
          <div class="publish-time">{{ getTime(jobDetail?.createTime) }} 发布</div>
        </div>

        <div class="section-title">欢迎酒店行业内优秀人才投递</div>
        <div v-if="jobDetail?.postDescribe" v-html="jobDetail.postDescribe" class="desc"></div>

        <div class="apply-wrap">
          <van-button class="btn" @click="goDetail()">立即投递</van-button>
        </div>
      </div>
    </div>
    <appFooter />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getJobDetail } from "@/api/index.js";
import { getTime } from "@/utils/utils.js";
import appFooter from "@/components/footer.vue";

const router = useRouter();
const route = useRoute();
const jobDetail = ref({});

// 获取岗位详情
const getData = () => {
  const id = route.params.id || "";
  if (!id) return;
  
  getJobDetail(id).then((res) => {
    jobDetail.value = res || {};
  });
};

// 跳投递页面
const goDetail = () => {
  const id = route.params.id || "";
  if (!id) return;
  router.push(`/join/send/${id}`);
};

const getLocationText = (job) => {
  const source = job.recruitLocationVo;
  if (!source) {
    return "--";
  }

  const locationType = Number(source.type);
  if (locationType === 0) {
    return "全国（中国大陆）";
  }

  // 提取名称数组
  const pickNames = (list) => (Array.isArray(list) ? list : []).map((item) => item?.name).filter(Boolean);
  
  // 优先级：区 > 市 > 省 > 国家
  const prioritizedNames = [
    pickNames(source.district),
    pickNames(source.city),
    pickNames(source.province),
    pickNames(source.country),
  ].find((list) => list.length > 0) || [];

  return prioritizedNames.length ? prioritizedNames.join("、") : "--";
};

const formatLocationText = (job) => {
	// const locationText = getJobLocationText(job);
	const locationText = getLocationText(job);
	return locationText.length > 18 ? `${locationText.slice(0, 18)}...` : locationText;
};

onMounted(() => {
  getData();
});
</script>

<style lang="scss" scoped>
.job-detail-page {
  min-height: calc(100vh - 91px);
  display: flex;
  flex-direction: column;
  background: #f1f1f1;
}

.job-detail {
  flex: 1;
  box-sizing: border-box;
  padding: 0 0 30rem;
}

.content-card {
  background: #fff;
  padding: 30rem 34rem 36rem;
}

.head-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20rem;
}

.job-title {
  flex: 1;
  font-size: 36rem;
  font-weight: 700;
  line-height: 1.3;
  color: #1f1f1f;
}

.salary {
  color: #ff7a00;
  font-size: 35rem;
  font-weight: 500;
  line-height: 1.3;
  white-space: nowrap;
}

.location-row {
  margin-top: 18rem;
  color: #8e8e8e;
  font-size: 24rem;
  display: flex;
  align-items: center;
  gap: 8rem;
}

.meta-block {
  margin-top: 20rem;
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 18rem;
}

.meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap; 
  color: #333;
  font-size: 24rem;

  > span {
    position: relative;
    line-height: 1.4; 
    padding: 0 20rem;
  }

  > span:first-child {
    padding-left: 0;
  }

  > span + span::before {
    content: "";
    width: 1px;
    height: 26rem;
    background: #e3e3e3;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

.publish-time {
  margin-top: 14rem;
  padding-left: 2rem;
  color: #999;
  font-size: 22rem;
  line-height: 1;
}

.section-title {
  margin-top: 30rem;
  color: #0a6b67;
  font-size: 28rem;
  font-weight: 700;
}

.desc {
  margin-top: 22rem;
  color: #1f1f1f;
  font-size: 28rem;
  line-height: 1.55;
  word-break: break-word;

  :deep(p) {
    margin: 0 0 12rem;
  }

  :deep(br) {
    line-height: 1;
  }
}

.apply-wrap {
  text-align: center;
  margin-top: 40rem;
}

.btn {
  width: 230rem;
  height: 78rem;
  line-height: 78rem;
  color: #fff;
  background: #005a57;
  border-radius: 10rem;
  border: none;
  font-size: 34rem;
}

:deep(.footer){
  margin-top: auto;
}
</style>
